export default "__VITE_ASSET__dc5de223__"